import Settings from "../domain/Settings";
import {RenderContext} from "../types/nativeTemplates";

export function init(): void {
	const settings = Settings.getInstance().nativeTemplates;

	if (!settings) {
		return;
	}

	const renderConfig = JSON.parse(JSON.stringify(settings.renderConfig));

	if (settings.darkModeType === 'nunl') {
		renderConfig.darkMode = document.querySelector('html')?.getAttribute('data-theme') === 'dark';
	}

	if (settings.darkModeType === 'cssColorScheme') {
		renderConfig.darkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
	}

	renderConfig.onModalOpen = (renderContext: RenderContext) => {
		renderContext.renderConfig.context?.slot?.pauseRefreshing?.();
	};
	renderConfig.onModalClose = (renderContext: RenderContext) => {
		renderContext.renderConfig.context?.slot?.resumeRefreshing?.();
	};

	window.advert.nativeTemplates = window.advert.nativeTemplates || {};
	window.advert.nativeTemplates.renderConfig = {
		...window.advert.nativeTemplates.renderConfig,
		...renderConfig
	};

	window.advert.nativeTemplates.feedContext = {
		...window.advert.nativeTemplates.feedContext,
		...settings.feedContext
	};
}
